import { connect } from 'react-redux'
import UI from './UI'

const mapStateToProps = ({ course }) => ({
  Duration: course.Course.Duration,
  ViewersCount: course.Course.ViewersCount,
  IsFree: course.Course.IsFree
})

export default connect(mapStateToProps, null)(UI)
